module.exports = __webpack_public_path__ + "public/img/碳排放 .bc415857.png";